import Definition from './Definition';
import DefinitionList from './DefinitionList';

export default angular.module('edge.platform.widgets.definition-list', [])
    .component('gwDefinitionList', DefinitionList)
    .component('gwDefinition', Definition);